import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import {
  Box, Typography, Grid, Card, CardContent, CircularProgress, Chip
} from '@mui/material';
import { Inventory, ShoppingCart, RequestQuote, Chat, TrendingUp } from '@mui/icons-material';

const SupplierDashboard = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const { data } = await api.get('/suppliers/dashboard/stats');
        setStats(data.data);
      } catch (err) { console.error(err); }
      setLoading(false);
    };
    loadStats();
  }, []);

  if (loading) return <Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>;

  const cards = [
    { icon: <Inventory sx={{ fontSize: 40, color: '#1565c0' }} />, label: t('my_products'), value: stats?.totalProducts || 0 },
    { icon: <ShoppingCart sx={{ fontSize: 40, color: '#2e7d32' }} />, label: 'Active Orders', value: stats?.activeOrders || 0 },
    { icon: <RequestQuote sx={{ fontSize: 40, color: '#e65100' }} />, label: 'Pending Quotes', value: stats?.pendingQuotes || 0 },
    { icon: <Chat sx={{ fontSize: 40, color: '#6a1b9a' }} />, label: 'Unread Messages', value: stats?.unreadMessages || 0 },
  ];

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>{t('supplier_dashboard')}</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Welcome back! Here's a summary of your activity.
      </Typography>

      <Grid container spacing={3}>
        {cards.map((card, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Card sx={{ '&:hover': { transform: 'translateY(-4px)', transition: '0.3s' } }}>
              <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {card.icon}
                <Box>
                  <Typography variant="h4" fontWeight={700}>{card.value}</Typography>
                  <Typography variant="body2" color="text.secondary">{card.label}</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Recent Orders */}
      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={600} gutterBottom>Recent Incoming Orders</Typography>
          {stats?.recentOrders?.length > 0 ? stats.recentOrders.map((order, i) => (
            <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, borderBottom: '1px solid #eee' }}>
              <Typography variant="body2" fontWeight={600}>{order.orderNumber}</Typography>
              <Typography variant="body2">{order.items?.length} items</Typography>
              <Chip label={order.status} size="small" />
              <Typography variant="body2" color="text.secondary">
                {new Date(order.createdAt).toLocaleDateString()}
              </Typography>
            </Box>
          )) : <Typography variant="body2" color="text.secondary">No recent orders</Typography>}
        </CardContent>
      </Card>
    </Box>
  );
};

export default SupplierDashboard;
